import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Avatar, darken } from '@mui/material';

export const ProductLogo = styled(Avatar)`
  ${p =>
    p.color &&
    css`
      background-color: ${darken(p.color!, 0.25)};
      color: ${p.theme.palette.getContrastText(p.color)};
    `}

  img {
    object-fit: contain;
  }
`;

ProductLogo.defaultProps = {
  variant: 'rounded',
};
